<template>
  <div v-if="canContactTeam">
    <ContactTeamModal :item="rm" modal-key="contactRM" v-if="rm && displayedModal" header-class="rm-bg"></ContactTeamModal>
    <ContactTeamModal :item="am" modal-key="contactAM" v-if="am && displayedModal" header-class="am-bg"></ContactTeamModal>
    <ContactTeamModal :item="srm" modal-key="contactSRM" v-if="srm && displayedModal" header-class="rm-bg"></ContactTeamModal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ContactTeamModal from './modals/ContactTeamModal.vue';

  export default {
    name: 'ContactTeamModals',
    components: {
      ContactTeamModal,
    },
    computed: {
      ...mapGetters('main', ['permissions', 'am', 'rm', 'srm', 'displayedModal', 'canContactTeam']),
    },
  };
</script>
